module.exports = {"region":"eu-west-1","userPoolId":"eu-west-1_fGqqkgVkw","identityPoolId":"eu-west-1:fa4da7ae-e97d-4773-8a4e-a54c1c95bd55","userPoolWebClientId":"6hm0fkm7vfmrkv7en9o44aqo52"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 856
// module chunks = 0